import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import remove from "@beeldit/core/services/remove";
import { EmailActionContext } from "./EmailActionContext";
import store from "@beeldit/core/services/store";

function useEmail(modelConfig: any) {
  const { elementId, setShowModal } = useContext(EmailActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store("bookings/send-email", { id: elementId })
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useEmail;
